import Vue from 'vue'
import axios from 'axios'
import store from '../store'
import appconst from '../utiltools/appconst'
import { handleAuthenticationFailure } from '../auth/authenticationFailure'
import {
  handleUnauthorizedResponse,
  prepareAuthenticatedRequest
} from '../auth/requestAuthentication'

const Axios = axios.create({
  baseURL: appconst.remoteServiceBaseUrl,
  timeout: 30000,
  withCredentials: true //必须添加，否则服务器无法设置COOKIE
})

const failAuthentication = () => handleAuthenticationFailure({
  clear: () => store.commit('unsetToken'),
  navigate: () => {
    if (window.location.pathname !== '/login') window.location.replace('/login')
  }
})

// 设置axios拦截器 cors设置
Axios.interceptors.request.use(
  async config => {
    config.headers.common[
      window.abp.localization.cookieName
    ] = window.abp.utils.getCookieValue(abp.localization.cookieName)
    config.headers.common[
      window.abp.multiTenancy.tenantIdCookieName
    ] = window.abp.multiTenancy.getTenantIdCookie()

    try {
      return await prepareAuthenticatedRequest(config, {
        readAuthentication: () => store.commit('readToken'),
        isUpload: request => typeof FormData !== 'undefined' && request.data instanceof FormData,
        isTokenExpired: () => store.getters.isTokenExpired,
        getRefreshToken: () => store.getters.refreshToken,
        getAccessToken: () => store.getters.token,
        refresh: () => store.dispatch('refreshToken')
      })
    } catch (error) {
      await failAuthentication()
      throw error
    }
  },
  err => {
    return Promise.reject(err)
  }
)

Axios.interceptors.response.use(
  respon => {
    //对响应数据做些事
    return respon
  },
  async error => {
    if (error.response && error.response.status === 401) {
      return handleUnauthorizedResponse(error, {
        getRefreshToken: () => store.getters.refreshToken,
        getAccessToken: () => store.getters.token,
        refresh: () => store.dispatch('refreshToken'),
        replay: config => Axios(config),
        failAuthentication
      })
    }

    if (
      !!error.response &&
      !!error.response.data.error &&
      !!error.response.data.error.message &&
      error.response.data.error.details
    ) {
      swal({
        title: error.response.data.error.message,
        text: error.response.data.error.details,
        icon: 'error'
      })
    } else if (
      !!error.response &&
      !!error.response.data.error &&
      !!error.response.data.error.message
    ) {
      swal({
        title: `${window.abp.localization.localize('Error')}: ${
          error.response.status
        }`,
        text: error.response.data.error.message,
        icon: 'error'
      })
    } else if (error.request) {
      swal({
        title: error.request.status,
        text: error.request.statusText,
        icon: 'error'
      })
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message)
      console.log(error.config)
    }
    console.error(`$axios error`)
    return Promise.reject(error)
  }
)
const AxiosProperty = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$axios', { value: Axios })
  }
}
Vue.use(AxiosProperty)

export default Axios



// WEBPACK FOOTER //
// ./src/plugins/AxiosPlugin.js